import {queries} from '@/shared/integrations/zero'
import {useQuery, useSuspenseQuery} from '@rocicorp/zero/react'

export function useGetStock(id: string | undefined) {
  return useQuery(queries.stocks.getStockById(id || ''))
}

export function useSuspenseGetStock(id: string | undefined) {
  return useSuspenseQuery(queries.stocks.getStockById(id || ''))
}
